import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { REVERT_REPLACE_INGREDIENT_MUTATION } from '../graphql/mutations'
import { REVERT_REPLACE_INGREDIENT } from '../redux/action-types'

const useRevertReplaceIngredientMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.ingredients.ingredients,
  )

  const mutate = useCallback(
    async replaceToken => {
      await apolloService.mutate(
        REVERT_REPLACE_INGREDIENT_MUTATION,
        {
          replaceToken,
        },
        dispatch,
        REVERT_REPLACE_INGREDIENT,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useRevertReplaceIngredientMutation
